import React, { FunctionComponent } from "react";
import AlertsContent from "./AlertsContent";
import styles from "./Alerts.module.scss";

const Alerts: FunctionComponent<AlertsContent> = (props) => {
    const { success } = props;

    return (
        <div className={styles.alerts}>
            {props.alerts ? props.alerts.map((alert => {
                return (<div key={alert} className={styles.alert}>{alert}</div>);
            }))
                : null}
            {props.successAlert && success ? (<div className={styles.successAlert}>{props.successAlert}</div>) : null}
        </div>
    );
};

export default Alerts;
